import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {useTranslation} from 'react-i18next';
import Indentation from '../Simple/Indentation';
import clsx from 'clsx';
import {SMCLockedToPlanToggle} from "../Simple/SMCLockedToPlanToggle";

function LockToPlanContainer({
    locked,
    onToggleLocked,
    children,
    icon,
    labelText,
    accessPolicy
}) {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <>
            <div className={classes.header}>
                <Indentation
                    indentation={30}
                    styleProps={{width: '100%', paddingBottom: '10px'}}
                >
                    <div className={clsx(classes.divWrapper, classes.line)}>
                        <div className={clsx(classes.divWrapper, classes.innerDivGridGap)}>
                            <img alt="" src={icon}/>
                            <label className={classes.label}>{labelText}</label>
                        </div>
                        <SMCLockedToPlanToggle className={classes.toggle}
                                               checked={locked}
                                               onChange={(clicked) => onToggleLocked(clicked)}
                                               label={(locked ? t("SMP.LOCK_TO_PLAN") : t("SMP.UNLOCK_TO_PLAN"))}
                                               labelWidth='140px'
                        />
                    </div>
                </Indentation>
            </div>
            {
                children &&
                <div className={clsx(locked && "locked",accessPolicy? locked && classes.accessPolicy: undefined )}>
                    {children}
                </div>
            }
        </>
    );
}

const useStyles = makeStyles({
    header: {
        background: '#FFF',
        color: '#304461',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '42px',
        width: '100%',
        display: 'flex',
        marginBottom: '11px',
        borderBottom: '1px solid #CFCFD2'
    },
    icon: {
        verticalAlign: 'middle',
        height: '18px',
        width: '18px',
        top: '4px',
        position: 'relative'
    },
    divWrapper:{
        display: 'flex',
        alignItems: 'center'
    },
    line:{
        justifyContent: 'space-between',
        height:'40px'
    },
    outerGridGap:{
        gridGap:'8px'
    },
    secondWrapperGridGap: {
        gridGap: '12px'
    },
    innerDivGridGap: {
        gridGap: '7px'
    },
    label: {
        fontSize: '18px',
        fontColor: '#333333',
        fontWeight: '500'
    },
    toggle:{
        marginRight: '13px'
    },
    accessPolicy: {
        minHeight: '200px',
        opacity: 0.6,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center 100px'
    }
})

LockToPlanContainer.propTypes = {
    locked: PropTypes.bool.isRequired,
    onToggleLocked: PropTypes.func.isRequired,
    children: PropTypes.node
}

export default LockToPlanContainer;